export const meta = {
  id: 'A12',
  slug: 'como-funciona',
  title: 'Como funciona sua Mentoria',
  description: 'Entenda como sessões, resumos compartilhados e acordos apoiam seu desenvolvimento.',
  profile: 'student',
  category: 'mentorias',
  type: 'flow',
  status: 'published',
  order: 160,
  keywords: ['mentoria', 'sessão', 'mentor', 'resumo compartilhado', 'acordos', 'nota privada'],
  previous: 'A11',
  next: 'A13',
  related: ['A11', 'A03', 'A04'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como funciona sua Mentoria

A Mentoria utiliza informações permitidas do seu desenvolvimento para tornar a conversa mais objetiva e conectada ao que você está vivendo no Personagrama.

Seu Mentor pode considerar contexto como objetivos, competências, Plano, Jornada, Formação, progresso e Evidências dentro da relação autorizada de Mentoria.

## Depois de uma sessão

Conforme o registro realizado, você pode encontrar:

- **Resumo compartilhado:** principais pontos que devem ficar disponíveis para você;
- **Acordos:** compromissos e próximos passos combinados;
- informações da sessão disponíveis para acompanhamento.

<HelpImage alt="Área de Mentoria do Aluno com sessão e acordos" pendingId="A12.3" />

<Callout type="important">
  **Notas privadas do Mentor não são exibidas ao Aluno.** O que precisa ser compartilhado com você deve estar nas áreas destinadas ao conteúdo compartilhado.
</Callout>

## O ciclo da Mentoria

**Sessão → reflexão → acordos → ação → Evidências/progresso → próxima Mentoria.**

Use os acordos como orientação para transformar a conversa em ação entre uma sessão e outra.
